var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: ["button", { disabled: _vm.disabled }],
      style: _vm.customStyle,
      on: { click: _vm.clickHandler }
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm._t("desc"),
      _vm._v(" "),
      _vm.loading ? _c("div", { staticClass: "button__loading" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Button/Button.vue?vue&type=template&id=4439b54f&
// module id = null
// module chunks = 